// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('change', this.#updateSelection);
    this.addEventListener('input', this.#updateSelection);
    this.#updateCharacterCount();
    this.#updateSelection();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('change', this.#updateSelection);
    this.removeEventListener('input', this.#updateSelection);
  }

  #updateSelection = () => {
    const summary = this.querySelector('[data-selection-summary]');
    const valueElement = this.querySelector('[data-selection-value]');
    const input = /** @type {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null} */ (
      this.querySelector('input[type="text"], textarea, select, input:checked')
    );
    if (!(summary instanceof HTMLElement) || !valueElement) return;
    const value = input?.value?.trim() || '';
    valueElement.textContent = value;
    summary.hidden = !value;
  };

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    if (!characterCount || !textInput) return;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
